module.exports = __webpack_public_path__ + "static/for-customers@2x-12b8837307822c9c3aa3bb7d38b9e2cb.jpg";